export enum DeclarationType {
    None = 0,
    Assisted,
    AssistedDisabled,
    DeathPension,
    Alimony,
    Active,
    Linked,
    SelfSponsored,
    MonthlyFee,
    MonthlyFeeCoop,
    MonthlyFeeCoopIR,   
    Dependant,
    Pensioner,
    Port,
    ContributionHistory,
    AdditionalContribution //aporte
}
